import React from "react";
import PropTypes from "prop-types";
import { TransparentBackgroundLogo } from "../../../assets/logo/TransparentBackgroundLogo";
// single global CSS now includes both title and badge styles:
import VerifiedBadgeStyle from "../../../assets/stylesheets/farm-detail/sections/VerifiedBadge.module.css";
import FarmDetailStyle from "../../../assets/stylesheets/farm-detail/FarmDetailPage.module.css";
import Logger from "../../../utils/logger";

// const log = Logger.create('VerifiedBadge');

const VERIFIED_BADGE_TITLE = "Verified by farmciti";

export default function FarmBadgeAndFeatures({
  title,
  address,
  region,
  rating
}) {
  return (
    <>

      {/* ─── VERIFIED BADGE + FEATURES ─── */}
      <div className={`${FarmDetailStyle["farmDetail-section"]} ${VerifiedBadgeStyle["vb-container"]}`}> 
        {/* ─── TITLE ─── */}
        <div className={VerifiedBadgeStyle["vb-title-container"]}>
          <h2 className={VerifiedBadgeStyle["vb-title"]}>{title}</h2>
          <h2 className={VerifiedBadgeStyle["vb-address"]}>{address}</h2>
        </div>
        <div className={VerifiedBadgeStyle["vb-badge"]}>
          <TransparentBackgroundLogo className={VerifiedBadgeStyle["vb-logo"]} aria-label="FarmCiti Logo" />
          <div className={VerifiedBadgeStyle["vb-text"]}>
            <p className={VerifiedBadgeStyle["vb-owner"]}>{VERIFIED_BADGE_TITLE}</p>
            <p className={VerifiedBadgeStyle["vb-region"]}>{region}</p>
          </div>

          {/* {rating != null && (
            <div className="vb-rating">
              <div className="vb-rating-row">
                <LeafLeft className="vb-leaf" aria-label="Leaf Left" />
                <span className="vb-score">{rating}</span>
                <LeafRight className="vb-leaf" aria-label="Leaf Right" />
              </div>
              <p className="vb-rateLabel">FARM RATE</p>
            </div>
          )} */}
        </div>

      </div>
    </>
  );
}

FarmBadgeAndFeatures.propTypes = {
  title:    PropTypes.string.isRequired,
  address:  PropTypes.string.isRequired,
  region:   PropTypes.string,
  rating:   PropTypes.number
};
